import React from 'react';
import styled, { css } from 'styled-components';
import parseStoryblokLink from '../../utils/parseStoryblokLink';
import Button from '../button';
import Container from '../container';
import VideoResourceItem from './VideoResourceItem';
import mq from '../../utils/mq';

const LatestVideosOuterContainer = styled.div`
  background-color: #fff;
  padding-top: 50px;
  padding-bottom: 104px;
  ${mq.mobile(css`
    padding-top: 64px;
    padding-bottom: 64px;
  `)};
`;

const TitleSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 44px;
`;

const Title = styled.h2`
  color: #161616;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 38.4px */
  letter-spacing: -0.64px;
`;

const CtaContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const LatestVideosContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 20px;
  ${mq.mobile(css`
    grid-template-columns: repeat(2, 1fr);
  `)};
`;

// card-level styles moved into VideoResourceItem

export default function LatestVideos({
  sectionTitle,
  sectionCtaLabel,
  sectionCtaLink,
  videoResourceItems
}: {
  sectionTitle: string;
  sectionCtaLabel: string;
  sectionCtaLink: any;
  videoResourceItems: any[];
}) {
  return (
    <LatestVideosOuterContainer>
      <Container>
        <TitleSection>
          <Title>{sectionTitle}</Title>
          <CtaContainer>
            <Button to={parseStoryblokLink(sectionCtaLink)} borderGrey>
              {sectionCtaLabel}
            </Button>
          </CtaContainer>
        </TitleSection>
        <LatestVideosContainer>
          {videoResourceItems.map((item) => (
            <VideoResourceItem key={item.id || item._uid} item={item} />
          ))}
        </LatestVideosContainer>
      </Container>
    </LatestVideosOuterContainer>
  );
}
